import { Box, Table, TableTdProps } from '@mantine/core';
import { Link } from 'react-router-dom';
import { ReactNode } from 'react';

type props = TableTdProps & {
  to: string;
  children: ReactNode;
  padding?: string | number;
  // isStatusColumn?: boolean;
  // status?: 'on' | 'off';
  // onTooltip?: string;
  // offTooltip?: string;
  // runStatus?: string;
  // runStatusTooltip?: string;
  color?: string;
};

const TableElementWithLink = ({
  to,
  children,
  padding = 'xs',
  // isStatusColumn,
  // status,
  // onTooltip,
  // offTooltip,
  // runStatus,
  // runStatusTooltip,
  color = '#586171',
  ...props
}: props) => {
  // let tooltipText = null;
  //
  // // Skip tooltips for status columns since StatusIndicator already has tooltips
  // if (!isStatusColumn) {
  //   if (status) {
  //     tooltipText = status === 'on' ? onTooltip : offTooltip;
  //   } else if (runStatus && runStatusTooltip) {
  //     tooltipText = runStatusTooltip;
  //   }
  // }

  return (
    <Table.Td p={0} {...props}>
      <Link
        to={to}
        style={{
          display: 'contents',
          textDecoration: 'none',
          // color: isStatusColumn ? '#0F172A' : color,
          color: color,
        }}
      >
        {/*{tooltipText ? (*/}
        {/*  <Tooltip*/}
        {/*    label={tooltipText}*/}
        {/*    position="top"*/}
        {/*    styles={{*/}
        {/*      tooltip: {*/}
        {/*        fontSize: '12px',*/}
        {/*        padding: '6px 10px',*/}
        {/*      },*/}
        {/*    }}*/}
        {/*  >*/}
        {/*    <Box p={'xs'} style={{ display: 'flex', alignItems: 'center' }}>*/}
        {/*      {children}*/}
        {/*    </Box>*/}
        {/*  </Tooltip>*/}
        {/*) : (*/}
        <Box p={padding} style={{ display: 'flex', alignItems: 'center' }}>
          {children}
        </Box>
        {/*)}*/}
      </Link>
    </Table.Td>
  );
};

export default TableElementWithLink;
